import { useSiteContentElementsAt } from '../contexts/SiteContentElementsProvider';

interface ContentEntry<T> {
    loading: boolean;
    error: any;
    contentTree: T;
}

export function createContentHook<T>(path: string) {
    /** Get `/Site Content/<path>` Pimcore content tree for a path specific to the used hook */
    function useContent(): ContentEntry<T>;
    /** Get `/Site Content/<path>/${key}` Pimcore content subtree for a path specific to the used hook */
    function useContent<K extends keyof T>(key: K): ContentEntry<T[K]>;
    /** Get `/Site Content/<path>/<key>/${subKey}` Pimcore content entry for a path specific to the used hook */
    function useContent<K extends keyof T, S extends keyof T[K]>(
        key: K,
        subKey: S
    ): ContentEntry<T[K][S]>;

    function useContent<K extends keyof T, S extends keyof T[K]>(key?: K, subKey?: S) {
        const ctx = useSiteContentElementsAt(path);
        const tree = ctx.contentTree as unknown as T;

        if (key !== undefined && subKey !== undefined) {
            return {
                loading: ctx.loading,
                error: ctx.error,
                contentTree: tree[key][subKey],
            } as ContentEntry<T[K][S]>;
        }

        if (key !== undefined) {
            return {
                loading: ctx.loading,
                error: ctx.error,
                contentTree: tree[key],
            } as ContentEntry<T[K]>;
        }

        return {
            loading: ctx.loading,
            error: ctx.error,
            contentTree: tree,
        } as ContentEntry<T>;
    }

    return useContent;
}
